import { supabase } from "../supabase";

/**
 * Fetch workspace members with their profile data
 */
export async function fetchWorkspaceMembers(workspaceId) {
  try {
    // Get workspace data including workspace_members array
    const { data: workspace, error: workspaceError } = await supabase
      .from("workspaces")
      .select("workspace_members")
      .eq("id", workspaceId)
      .single();

    if (workspaceError) throw workspaceError;

    if (!workspace?.workspace_members?.length) {
      return [];
    }

    // Fetch profiles for workspace members
    const { data: profiles, error: profilesError } = await supabase
      .from("profiles")
      .select("id, full_name, email, avatar_url")
      .in("id", workspace.workspace_members);

    if (profilesError) throw profilesError;

    return profiles || [];
  } catch (error) {
    console.error("Error fetching workspace members:", error);
    return [];
  }
}

/**
 * Update user's profile to remove workspace from user_workspaces array
 */
export async function updateUserWorkspacesOnRemoval(userId, workspaceId) {
  try {
    // First, get the current user_workspaces array
    const { data: profile, error: fetchError } = await supabase
      .from("profiles")
      .select("user_workspaces")
      .eq("id", userId)
      .single();

    if (fetchError) {
      console.error("Error fetching user profile:", fetchError);
      return false;
    }

    // Remove the workspace ID from the user_workspaces array
    const currentWorkspaces = profile?.user_workspaces || [];
    const updatedWorkspaces = currentWorkspaces.filter(
      (id) => id !== workspaceId
    );

    // Update the profile with the new user_workspaces array
    const { error: updateError } = await supabase
      .from("profiles")
      .update({ user_workspaces: updatedWorkspaces })
      .eq("id", userId);

    if (updateError) {
      console.error("Error updating user workspaces:", updateError);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error updating user workspaces on removal:", error);
    return false;
  }
}
